/** 状态枚举 */
export const STATE_ENUM = {
  disabled: {
    value: 1,
    label: "禁用",
  },
  unDisabled: {
    value: 2,
    label: "启用",
  },
};
